import { FC } from 'react';
import { Link, To } from 'react-router-dom';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

import { Icon } from '@app/components';

import './BackToRoute.scss';

interface BackToRouteProps {
  text: string;
  to: To;
}

export const BackToRoute: FC<BackToRouteProps> = ({ text, to }) => (
  <Link className="eb-button eb-button--link backToRouteLink" to={to}>
    <Icon icon={faArrowLeft}>{text}</Icon>
  </Link>
);
